export const IUBENDA_PRIVACY_POLICY_URL =
  "https://www.iubenda.com/privacy-policy/20337938";

export const IUBENDA_COOKIE_POLICY_URL =
  "https://www.iubenda.com/privacy-policy/20337938/cookie-policy";

export const IUBENDA_SCRIPT_ID = "iubenda-js";

export const IUBENDA_SCRIPT_SRC = "https://cdn.iubenda.com/iubenda.js";

export const IUBENDA_EMBED_CLASS =
  "iubenda-nostyle no-brand iubenda-noiframe iubenda-embed";

export const IUBENDA_PREFERENCES_LINK_CLASS = "iubenda-cs-preferences-link";
